module.exports = __webpack_public_path__ + "img/ch17_09_回收站_v2.085b46c5.png";